import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import { useRole, ROLES } from '../../../contexts/RoleContext';
import cx from '../utils/cx';
import NavDropdown from './NavDropdown';
import styles from './Navbar.module.css';

const UserMenu = ({ user }) => {
  const { logout } = useAuth();
  const { hasRole, isPro } = useRole();
  const navigate = useNavigate();
  const isAdmin = hasRole(ROLES.ADMIN);
  const initial = (user.email?.[0] || 'U').toUpperCase();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/');
    } catch (error) {
      console.error('Failed to log out:', error);
    }
  };

  return (
    <>
      {isPro() && <span className={styles.pro}>PRO</span>}
      <NavDropdown
        align="end"
        ariaLabel="Account menu"
        triggerClassName={cx(styles.avatar, isAdmin && styles.avatarAdmin)}
        label={<span aria-hidden="true">{initial}</span>}
      >
        {user.email && <li className={styles.menuLabel}>{user.email}</li>}
        <li>
          <Link className={styles.menuItem} to="/profile">
            Profile
          </Link>
        </li>
        <li>
          {/* Admins get the full listings grid; everyone else lands on the NJ counties map. */}
          <Link className={styles.menuItem} to={isAdmin ? '/properties' : '/nj-counties'}>
            Browse properties
          </Link>
        </li>
        {isAdmin && (
          <li>
            <Link className={styles.menuItem} to="/admin">
              Admin panel
            </Link>
          </li>
        )}
        <li className={styles.menuDivider} role="separator" />
        <li>
          <button type="button" className={cx(styles.menuItem, styles.danger)} onClick={handleLogout}>
            Log out
          </button>
        </li>
      </NavDropdown>
    </>
  );
};

export default UserMenu;
